var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notfound flex"},[_c('img',{attrs:{"src":require("../assets/404.png"),"alt":""}}),_c('div',{staticClass:"desc"},[_c('div',{staticClass:"num"},[_vm._v("404")]),_c('div',[_vm._v("抱歉，你访问的页面地址有误，"),_c('br'),_vm._v("或者该页面不存在")])])])
}]

export { render, staticRenderFns }